﻿module.exports = (function ($) {
    return {
        results: null,
        isHomePage: false,
        mapZoom: null,
        mapCenter: null,
        markers: [],
        init: function () {
            var self = this; // Used to reference 'this' inside anonymous functions (e.g. click events)

            this.initForm();

            if ($(".historyMapContainer").length > 0) {
                // On first load get results.
                self.search();
            }

            // home page item
            if ($('.disasterMap').length > 0) {
                // On first load get results.
                self.isHomePage = true;
                self.search();
            }

            var $smallScreenFilterToggle = $(".historyMapContainer__filterToggle").find("a"),
                $filterActiveStateTarget = $("body");

            // small screen device filter toggle
            $smallScreenFilterToggle.on("click touch", function ($event) {
                $event.preventDefault();
                $filterActiveStateTarget.toggleClass("search-filters-active");
            });
        },
        initForm: function () {
            var self = this;

            // If we are on the histry map page.
            if ($(".historyMapContainer").length > 0) {
                // Create reset button
                $("#year-search-reset").click(function () {
                    $("#startyear option")[0].selected = true;
                    $("#endyear option")[0].selected = true;

                    // Get new results
                    if ($("#selectedCategories").val() === "") {
                        var data = "{\"results\":[],\"count\":5,\"skip\":0,\"take\":5}";
                        self.createMap(self, data);
                    } else {
                        self.search();
                    }
                });

                $("#categories-select-all").click(function () {
                    $(this).toggleClass("js_all_selected");
                    var selectall = $(this).hasClass("js_all_selected");
                    if (selectall) {
                        $(this).html("Select None");
                    } else {
                        $(this).html("Select All");
                    }
                    var currentCategories = "";
                    $("#selectedCategories").val("");
                    $.each($("#category-selection li a"),
                        function (i, category) {

                            var value = $(this).attr("data-value");

                            if (selectall) {
                                $(this).removeClass("active").addClass("active");
                            } else {
                                $(this).removeClass("active");
                            }

                            if ($(this).hasClass("active")) {
                                if (currentCategories.length === 0) {
                                    currentCategories += value;
                                } else {
                                    currentCategories += "," + value;
                                }
                            }

                            // Set new categories string
                            $("#selectedCategories").val(currentCategories.replace(",,", ","));
                        });
                    // Get new results
                    if (currentCategories === "") {
                        var data = "{\"results\":[],\"count\":5,\"skip\":0,\"take\":5}";
                        self.createMap(self, data);
                    } else {
                        self.search();
                    }
                }).addClass("js_all_selected").html("Select None");

                // Create year selection events.
                $("#startyear, #endyear").change(function () {

                    // Get new results
                    if ($("#selectedCategories").val() === "") {
                        var data = "{\"results\":[],\"count\":5,\"skip\":0,\"take\":5}";
                        self.createMap(self, data);
                    } else {
                        self.search();
                    }
                });
            }

            $("#category-selection li a").click(function () {
                var value = $(this).attr("data-value");
                var currentCategories = $("#selectedCategories").val();
                if ($(this).hasClass("active")) {
                    var categories = currentCategories.split(",").filter(function (e) { return e });
                    currentCategories = currentCategories.replace("," + value, "");
                    $(this).removeClass("active");
                }
                else {
                    currentCategories = currentCategories + "," + value;
                    $(this).addClass("active");
                }
                // Set new categories string
                $("#selectedCategories").val(currentCategories.replace(",,", ","));

                // Get new results
                if ($("#selectedCategories").val() === "") {
                    var data = "{\"results\":[],\"count\":5,\"skip\":0,\"take\":5}";
                    self.createMap(self, data);
                } else {
                    self.search();
                }

            });

        },
        createMarkers: function (map, searchJson) {

            var $dateFormat = require("dateformat");

            // Init markers
            var self = this;
            // clear markers.
            self.markers = [];

            var $historyMapDetails = $("#historyMapDetails");


            // Get all the filtered events/resources results and and lat/long
            $.each(searchJson.results, function (i, result) {
                var iconUrl = window.location.protocol + "//" + window.location.hostname + "/assets/images/maps/retina/";
                // get type of result and set pin.
                switch (result.disasterCategory.toLowerCase()) {
                    case "biosecurity":
                        iconUrl += "biosecurity-pin.png";
                        break;
                    case "fire - bushfire":
                        iconUrl += "fire-pin.png";
                        break;
                    case "criminal":
                        iconUrl += "criminal-pin.png";
                        break;
                    case "cyclone":
                        iconUrl += "cyclone-pin.png";
                        break;
                    case "earthquake":
                        iconUrl += "earthquake-pin.png";
                        break;
                    case "environment":
                        iconUrl += "environment-pin.png";
                        break;
                    case "flood":
                        iconUrl += "flood-pin.png";
                        break;
                    case "health":
                        iconUrl += "health-pin.png";
                        break;
                    case "industrial":
                        iconUrl += "industrial-pin.png";
                        break;
                    case "landslide":
                        iconUrl += "landslide-pin.png";
                        break;
                    case "maritime/coastal":
                        iconUrl += "maritimeCoastal-pin.png";
                        break;
                    case "storm":
                        iconUrl += "storm-pin.png";
                        break;
                    case "tornado":
                        iconUrl += "tornado-pin.png";
                        break;
                    case "transport":
                        iconUrl += "transport-pin.png";
                        break;
                    case "tsunami":
                        iconUrl += "tsunami-pin.png";
                        break;
                    case "fire - urban":
                        iconUrl += "urbanFire-pin.png";
                        break;
                    case "other":
                    case "otherDisaster":
                        iconUrl += "other-pin.png";
                        break;
                    default:
                        iconUrl += "other-pin.png";
                        break;
                }

                // Create a new marker.
                if (result.location) {

                    // Create new lat/long
                    var latLng = new google.maps.LatLng(result.location.latitude, result.location.longitude);

                    // Check existing markers array for duplicate position and offset a little
                    if (self.markers.length != 0) {
                        for (i = 0; i < self.markers.length; i++) {
                            var existingMarker = self.markers[i];
                            var pos = existingMarker.getPosition();
                            if (latLng.equals(pos)) {
                                var a = 360.0 / 90;
                                var newLat = pos.lat() + -.002 * Math.cos((+a * i) / 180 * Math.PI);  //x
                                var newLng = pos.lng() + -.002 * Math.sin((+a * i) / 180 * Math.PI);  //Y
                                latLng = new google.maps.LatLng(newLat, newLng); // set the new lat long
                            }
                        }
                    }

                    // Build a marker image of retina compatibility
                    var mapIcon = {
                        url: iconUrl,
                        scaledSize: new google.maps.Size(58, 59.5)
                    };

                    // Add marker
                    var marker = new google.maps.Marker({
                        position: latLng,
                        map: map,
                        title: result.name,
                        animation: google.maps.Animation.DROP,
                        icon: mapIcon // Get a custom one made
                    });

                    var offsetCenter = 0;
                    if (self.isHomePage) {
                        // Create infoWindow for the popup
                        var infoContent = '<div class="resource-info-window">' +
                            '<a href="' + result.url + '"><span class="resource-body">' +
                            '<span class="resource-name"><strong>' + result.name + '</strong></span>' +
                            '<span class="resource-region">' + result.region + '</span>' +
                            '<span class="resource-dates">' + (result.startDate != null ? $dateFormat(new Date(result.startDate), "d/m/yyyy") : '') + (result.endDate != null ? ' - ' + $dateFormat(new Date(result.endDate), "d/m/yyyy") : '') + '</span>' +
                            '</span></a>' + // /.resource-body
                            '</div>'; // /.resource.resourceInfoMap

                        // Add info window
                        marker.infoWindow = new google.maps.InfoWindow({
                            content: infoContent,
                            maxWidth: 264,
                            pixelOffset: new google.maps.Size(188, 100)
                        });

                        // *
                        // START INFOWINDOW CUSTOMIZE.
                        // The google.maps.event.addListener() event expects
                        // the creation of the infowindow HTML structure 'domready'
                        // and before the opening of the infowindow, defined styles are applied.
                        // *
                        google.maps.event.addListener(marker.infoWindow, 'domready', function () {
                            var iwOuter = $('.gm-style-iw');
                            iwOuter.attr('style', function (i, s) {
                                return s + ' -webkit-box-shadow:0 14px 18px 1px rgba(0,0,0,0.2); box-shadow:0 14px 18px 1px rgba(0,0,0,0.2); max-width:264px;-webkit-border-radius: 4px;border-radius: 4px;';
                            });
                            iwOuter.children(':nth-child(1)').attr('style', function (i, s) {
                                return s + ' display:block;';
                            });
                            var iwBackground = iwOuter.prev();
                            iwBackground.children(':nth-child(2)').css({
                                'display': 'none'
                            });
                            iwBackground.children(':nth-child(4)').css({
                                'display': 'none'
                            });
                            iwBackground.children(':nth-child(1)').css({
                                'display': 'none'
                            });
                            iwBackground.children(':nth-child(3)').css({
                                'display': 'none'
                            });
                            iwOuter.next().css({
                                'display': 'none'
                            });
                        });
                    }
                    else {
                        // small info window.
                        var smallInfoContent = "<div class=\"hook\"><span>" + result.name + "</span> " + new Date(result.startDate).getFullYear() + "</div>";

                        // Add info window
                        marker.infoWindow = new google.maps.InfoWindow({
                            content: smallInfoContent,
                            maxWidth: 500,
                            title: result.name,
                            pixelOffset: new google.maps.Size(35, 66),
                            zIndex: 198408 // this is used to target infoboxes in CSS
                        });

                        google.maps.event.addListener(marker.infoWindow, 'domready', function () {
                            var iwOuter = $('.gm-style-iw');
                            iwOuter.attr('style', function (i, s) {
                                return s + ' margin-left:' + (iwOuter.width() / 2) + 'px';
                            });
                        });
                    }

                    marker.addListener("click", function () {

                        if (marker.getIcon().url.indexOf("-active") != -1) {
                            // remove selections.
                            this.infoWindow.close();
                            //marker.getIcon().url.replace("-active", "");

                            marker.setIcon({
                                url: marker.getIcon().url.replace("-active", ""),
                                scaledSize: new google.maps.Size(58, 59.5)
                            });

                            $historyMapDetails.find(".historyMapDetails").removeClass("active");
                        }
                        else {

                            // clear marker infoWindows
                            $.each(self.markers, function (index, m) {
                                if (m.getIcon().url.indexOf("-active") != -1) {

                                    //m.icon.url.replace("-active", "");
                                    m.setIcon({
                                        url: m.getIcon().url.replace("-active", ""),
                                        scaledSize: new google.maps.Size(58, 59.5)
                                    });
                                }
                                this.infoWindow.close();
                            });

                            // close any open details
                            $historyMapDetails.find(".historyMapDetails").removeClass("active");

                            setTimeout(function () {
                                $.ajax({
                                    url: '/umbraco/Api/searchapi/Event',
                                    type: 'GET',
                                    data: {
                                        resourceId: result.resourceId
                                    },
                                    success: function (data) {
                                        if (data.length > 0) {
                                            self.loadMapDetails(self, data);
                                            setTimeout(function () { $historyMapDetails.find(".historyMapDetails[data-resource-id=\"" + result.resourceId + "\"]").addClass("active"); }, 250);
                                        }
                                    },
                                    error: function (result) {
                                        console.log("An error occurred when getting similar events.");
                                    }
                                });
                            }, 250);


                            // Append the similar event using an ajax call.
                            if ($historyMapDetails.find(".active").children('div').find(".historyMapDetails__similar").length == 0) {
                                self.setSimilarEvents(result.resourceId);
                            }

                            
                            marker.infoWindow.open(map, marker);
                            marker.setIcon({
                                url: marker.getIcon().url.replace(".png", "-active.png"),
                                scaledSize: new google.maps.Size(58, 59.5)
                            });



                            //var scale = Math.pow(2, map.getZoom());
                            //var pixelCoordsCenter = map.getProjection().fromLatLngToPoint(map.getCenter());
                            //var pixelCoordsMarker = map.getProjection().fromLatLngToPoint(marker.getPosition());
                            //var pixelOffset = new google.maps.Point(
                            //    Math.floor((pixelCoordsMarker.x - pixelCoordsCenter.x) * scale + $("#google-map").width() / 2),
                            //    Math.floor((pixelCoordsMarker.y - pixelCoordsCenter.y) * scale + $("#google-map").height() / 2)
                            //);
                            //if (pixelOffset.x > ($("#google-map").width() - 290)) {
                                //map.panTo(marker.getPosition());
                            //}
                            map.panTo(marker.getPosition());
                            //console.log(offsetCenter);
                            map.panBy(290, 0);


                        }

                    });

                    // Add to collection
                    self.markers.push(marker);
                }
            });

            return self.markers;
        },
        setSimilarEvents: function (resourceId) {
            var self = this;
            // Perform and ajax request to get the content
            $.ajax({
                url: '/umbraco/Api/searchapi/SimilarEvents',
                type: 'GET',
                data: {
                    resourceId: resourceId
                },
                success: function (data) {
                    if (data.length > 0) {

                        var similarTemplate = $('<div class="historyMapDetails__similar">' +
                            '<h2>Similar Events</h2>' +
                                '<div class="historyMapDetails__similar__events"></div>' +
                            '</div>');

                        var similarItemTemplate = '<div class="historyMapDetails__similar__item">' +
                            '<span class="historyMapDetails__similar__type"></span>' +
                                '<a class="historyMapDetails__similar__title" href=""></a>' +
                        '</div>';

                        $.each(data, function (index, event) {
                            var item = $(similarItemTemplate).clone();
                            $(item).find('.historyMapDetails__similar__type').text(event.disasterCategory);
                            $(item).find('.historyMapDetails__similar__title').text(event.name + ", " + event.region + " " + (event.startDate != null ? new Date(event.startDate).getFullYear() : ""));
                            $(item).find('.historyMapDetails__similar__title').attr("href", event.url);
                            similarTemplate.find('.historyMapDetails__similar__events').append(item);
                        })

                        $('#historyMapDetails').find(".historyMapDetails[data-resource-id=\"" + resourceId + "\"]").children('div').first().append(similarTemplate);
                    }
                },
                error: function (result) {
                    console.log("An error occurred when getting similar events.");
                }
            });
        },
        loadMapDetails: function (self, data) {

            var $dateFormat = require("dateformat");

            var $historyMapDetails = $("#historyMapDetails");

            var $determinePercentage = function ($value, $maxValue) {
                return (($value / $maxValue) * 100);
            };

            var $scaleMax__deaths = 1000,
                $scaleMax__insuranceCost = 10000000,
                $scaleMax__homesDestroyed = 500,
                $scaleMax__injuries = 2000,
                $scaleMax__businessesDestroyed = 500;

            // clear div
            $historyMapDetails.empty();

            // create event details
            $.each(data, function () {

                var $startDate = Date.parse(this.startDate),
                    $endDate = this.endDate != null ? Date.parse(this.endDate) : null;

                var $percentage__deaths = $determinePercentage(this.deaths, $scaleMax__deaths),
                    $percentage__insuranceCost = $determinePercentage(this.rawInsuranceCost, $scaleMax__insuranceCost),
                    $percentage__homesDestroyed = $determinePercentage(this.homesDestroyed, $scaleMax__homesDestroyed),
                    $percentage__injuries = $determinePercentage(this.injuries, $scaleMax__injuries),
                    $percentage__businessesDestroyed = $determinePercentage(this.businessesDestroyed, $scaleMax__businessesDestroyed);


                var $html = "";

                $html += "<div class=\"historyMapDetails\" data-resource-id=\"" + this.resourceId + "\" data-category=\"" + this.disasterCategory + "\">";
                $html += "<div>";
                $html += "<div class=\"historyMapDetails__header\">";
                $html += "<a href=\"#close\" class=\"close-details\"></a>";
                $html += "<h3>" + this.disasterCategory + "</h3>";
                $html += "<h2>" + this.name + "</h2>";
                $html += "<span>" + this.region + "</span>";

                $html += "<time>" + $dateFormat($startDate, "d/m/yyyy") + ($endDate != null ? " - " + $dateFormat($endDate, "d/m/yyyy") : "") + "</time>";
                $html += "</div>";
                $html += "<div class=\"historyMapDetails__statistics\">";
                $html += "<ul>";
                if ($percentage__deaths > 0) {
                    $html += "<li>";
                    $html += "<div class=\"progress-bar\" " +
                        "role=\"progressbar\" " +
                        "aria-valuenow=\"" + $percentage__deaths + "\" " +
                        "aria-valuemin=\"0\" " +
                        "aria-valuemax=\"" + $scaleMax__deaths + "\" " +
                        "style=\"width:" + ($percentage__deaths <= 100 ? $percentage__deaths : 100) + "%;\">";
                    $html += "<span>" + this.deaths + "</span>";
                    $html += "</div>";
                    $html += "<span>Fatalities</span>";
                    $html += "</li>";
                }
                if ($percentage__insuranceCost > 0) {
                    $html += "<li>";
                    $html += "<div class=\"progress-bar\" " +
                        "role=\"progressbar\" " +
                        "aria-valuenow=\"" + $percentage__insuranceCost + "\" " +
                        "aria-valuemin=\"0\" " +
                        "aria-valuemax=\"" + $scaleMax__insuranceCost + "\" " +
                        "style=\"width:" + ($percentage__insuranceCost <= 100 ? $percentage__insuranceCost : 100) + "%;\">";
                    $html += "<span>" + this.insuranceCost + "</span>";
                    $html += "</div>";
                    $html += "<span>Insurance Costs</span>";
                    $html += "</li>";
                }
                if ($percentage__homesDestroyed > 0) {
                    $html += "<li>";
                    $html += "<div class=\"progress-bar\" " +
                        "role=\"progressbar\" " +
                        "aria-valuenow=\"" + $percentage__homesDestroyed + "\" " +
                        "aria-valuemin=\"0\" " +
                        "aria-valuemax=\"" + $scaleMax__homesDestroyed + "\" " +
                        "style=\"width:" + ($percentage__homesDestroyed <= 100 ? $percentage__homesDestroyed : 100) + "%;\">";
                    $html += "<span>" + this.homesDestroyed + "</span>";
                    $html += "</div>";
                    $html += "<span>Home(s) Destroyed</span>";
                    $html += "</li>";
                }
                if ($percentage__injuries > 0) {
                    $html += "<li>";
                    $html += "<div class=\"progress-bar\" " +
                        "role=\"progressbar\" " +
                        "aria-valuenow=\"" + $percentage__injuries + "\" " +
                        "aria-valuemin=\"0\" " +
                        "aria-valuemax=\"" + $scaleMax__injuries + "\" " +
                        "style=\"width:" + ($percentage__injuries <= 100 ? $percentage__injuries : 100) + "%;\">";
                    $html += "<span>" + this.injuries + "</span>";
                    $html += "</div>";
                    $html += "<span>Injured</span>";
                    $html += "</li>";
                }
                if ($percentage__businessesDestroyed > 0) {
                    $html += "<li>";
                    $html += "<div class=\"progress-bar\" " +
                        "role=\"progressbar\" " +
                        "aria-valuenow=\"" + $percentage__businessesDestroyed + "\" " +
                        "aria-valuemin=\"0\" " +
                        "aria-valuemax=\"" + $scaleMax__businessesDestroyed + "\" " +
                        "style=\"width:" + ($percentage__businessesDestroyed <= 100 ? $percentage__businessesDestroyed : 100) + "%;\">";
                    $html += "<span>" + this.businessesDestroyed + "</span>";
                    $html += "</div>";
                    $html += "<span>Businesses Destroyed</span>";
                    $html += "</li>";
                }
                $html += "</ul>";
                $html += "</div>";
                $html += "<a class=\"viewBtn\" href=\"" + this.url + "\">View Event</a>";
                $html += "</div>";
                $html += "</div>";

                $historyMapDetails.append($html);
            });


            // details close button
            $("a.close-details").on("click touch", function ($event) {
                $event.preventDefault();
                $(this).parents(".historyMapDetails").removeClass("active");
                // clear marker infoWindows
                $.each(self.markers, function () {
                    if ((this.getIcon().url).indexOf("-active") != -1) {
                        this.setIcon({
                            url: this.getIcon().url.replace("-active", ""),
                            scaledSize: new google.maps.Size(58, 59.5)
                        });
                    }
                    this.infoWindow.close();
                });
            });
        },
        createMap: function (self, searchJson) {

            // center of aust lat/long
            var $auLat = -24.349627,
                $auLng = 133.575275,
                $latOffset = 4,
                $lngOffset = 10, // for centering minus sidebar space (desktop)
                $latOffsetTablet = 14, // move map of aus up in container (tablet)
                $latOffsetMobile = 38; // move map of aus up in container (mobile)

            var $currentBreakPoint = (window.innerWidth < 767 ? 0 : (window.innerWidth < 1023 ? 1 : 2)),
                $center = ($currentBreakPoint == 2
                    ? new google.maps.LatLng(($auLat - $latOffset), ($auLng + $lngOffset))
                    : ($currentBreakPoint == 1
                    ? new google.maps.LatLng(($auLat - $latOffsetTablet), $auLng)
                    : new google.maps.LatLng(($auLat - $latOffsetMobile), $auLng))),
                $zoom = ($currentBreakPoint == 0 ? 3 : ($currentBreakPoint == 1 ? 4 : 5));

            var mapOptions = {
                zoom: self.mapZoom ? self.mapZoom : $zoom,
                panControl: false,
                streetViewControl: false,
                mapTypeControl: false,
                scrollwheel: false,
                maxZoom: 16,
                center: self.mapCenter ? self.mapCenter : $center,
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.TOP_LEFT
                },
                styles: [
                    {
                        "featureType": "administrative",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "off"
                            },
                            {
                                "color": "#95aabb"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#444444"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.province",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.province",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#ababab"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.land_parcel",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#f2f2f2"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape.man_made",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape.man_made",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape.man_made",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape.natural.terrain",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f2f2f2"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "all",
                        "stylers": [
                            {
                                "saturation": -100
                            },
                            {
                                "lightness": 45
                            },
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "weight": "1"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            },
                            {
                                "weight": "1.5"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            },
                            {
                                "weight": "0.25"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            },
                            {
                                "weight": "1.15"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#46bcec"
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#95aabb"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#ffffff"
                            }
                        ]
                    }
                ]
            };

            // Set up google map
            var map = new google.maps.Map(document.getElementById("google-map"), mapOptions);

            var markers = self.createMarkers(map, searchJson);

            //// If user has no changed map, set bound center and offset.
            //if (!self.mapZoom && !self.mapCenter)
            //{
            //    var bounds = new google.maps.LatLngBounds();
            //    for (var i = 0; i < markers.length; i++) {
            //        bounds.extend(markers[i].getPosition());
            //    }
            //    map.fitBounds(bounds);
            //}

            // Add a marker clusterer to manage the markers.
            var markerCluster = new MarkerClusterer(map, markers,
            {
                imagePath: window.location.protocol + "//" + window.location.hostname + "/assets/images/maps/cluster-pin",
                gridSize: 50,
                zoomOnClick: false,
                maxZoom: 14,
                styles: [{
                    url: "../assets/images/maps/cluster1.svg",
                    height: 57,
                    width: 57,
                    textColor: "#fff",
                    textSize: 14
                }, {
                    url: "../assets/images/maps/cluster2.svg",
                    height: 69,
                    width: 69,
                    textColor: "#fff",
                    textSize: 14
                }, {
                    url: "../assets/images/maps/cluster2.svg",
                    height: 69,
                    width: 69,
                    textColor: "#fff",
                    textSize: 14
                }]
            });

            google.maps.event.addDomListener(window, "resize", function () {

                if (self.isHomePage) {
                    // map is loaded. resize to fit category list
                    $('.disasterMap__map').attr('style', function (index, attr) {
                        return attr + (' min-height:' + $('.historyMapContainer__searchFilters')[0].scrollHeight + 'px;');
                    });
                }

                var center = map.getCenter();
                google.maps.event.trigger(map, "resize");
                map.setCenter(center);

                self.saveMapState(map)
            });

            if (self.isHomePage) {
                google.maps.event.addListenerOnce(map, 'idle', function () {
                    // map is loaded. resize to fit category list
                    $('.disasterMap__map').attr('style', function (index, attr) {
                        return attr + (' min-height:' + $('.historyMapContainer__searchFilters')[0].scrollHeight + 'px;');
                    });
                    var center = map.getCenter();
                    google.maps.event.trigger(map, "resize");
                    map.setCenter(center);
                    // Set the zoom one lvl higher so we see whole of aus
                    map.setZoom(map.getZoom() - 1);
                });

                self.saveMapState(map)
            }

            google.maps.event.addListener(map, 'zoom_changed', function () {
                self.saveMapState(map)
            });
            google.maps.event.addListener(map, 'dragend', function () {
                self.saveMapState(map)
            });

            // On map click, enable scroll zoom
            google.maps.event.addListener(map, 'click', function () {
                map.setOptions({
                    scrollwheel: true
                });
            });

            // on map out, disable zoom.
            google.maps.event.addListener(map, 'mouseout', function () {
                map.setOptions({
                    scrollwheel: false
                });
            });

            var clusterInfoWindow = new google.maps.InfoWindow({
                zIndex: 198408 // this is used to target infoboxes in CSS
            });

            google.maps.event.addListener(markerCluster, "clusterclick", function (cluster) {
                map.fitBounds(cluster.getBounds());
                map.setZoom(map.getZoom() - 1); // move zoom up so we can see all
            });

        },
        saveMapState: function (map) {
            var self = this;
            self.mapZoom = map.getZoom();
            self.mapCenter = map.getCenter();
        },
        search: function (options) {

            var self = this;
            var startYear = $("#startyear").length > 0 ? $("#startyear").val() : null;
            var endYear = $("#endyear").length > 0 ? $("#endyear").val() : null;
            var categories = $("#selectedCategories").length > 0 ? $("#selectedCategories").val().split(",").filter(function (e) { return e }) : null;

            // Perform and ajax search
            $.ajax({
                url: "/umbraco/Api/searchapi/Resource",
                type: "POST",
                traditional: true,
                data: {
                    startyear: startYear,
                    endyear: endYear,
                    categories: categories,
                    ResourceType: "disaster event"
                },
                success: function (data) { self.createMap(self, data); },
                error: function (result) {
                    console.log("An error occurred when searching.");
                }
            });

        }
    };
});